"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TextInput_1 = __importDefault(require("../../../core/inputs/TextInput"));
var Select_1 = __importDefault(require("../../../core/inputs/Select"));
var Button_1 = __importDefault(require("../../../core/buttons/Button"));
var FileInput_1 = __importDefault(require("../../../core/inputs/FileInput"));
var Loading_1 = __importDefault(require("../../../core/Loading"));
var Notification_1 = require("../../../core/Notification");
var use_notification_1 = require("../../../../hooks/use-notification");
var CustomerAdd = function (_a) {
    var submitHandler = _a.submitHandler, uploadHandler = _a.uploadHandler;
    var _b = react_1.useState(null), attachments = _b[0], setAttachments = _b[1];
    var _c = react_1.useState(false), busy = _c[0], setBusy = _c[1];
    var fileErrorHandler = function (error) {
        notification({
            variant: Notification_1.NotificationVariants.ERROR,
            message: error
        });
    };
    var fileSelectHandler = function (name, fileList) {
        setAttachments(fileList);
    };
    var notification = use_notification_1.useNotification();
    var handleUpload = function () {
        if (!attachments || attachments.length === 0) {
            return;
        }
        uploadHandler(attachments);
        setAttachments(null);
    };
    return (react_1.default.createElement("div", { className: "customer-add" },
        react_1.default.createElement("h2", null, "Add New Customer"),
        react_1.default.createElement("form", { onSubmit: submitHandler },
            react_1.default.createElement("div", { className: "table__tr flex flex-row" },
                react_1.default.createElement("div", { className: "table__td" },
                    react_1.default.createElement(TextInput_1.default, { type: "text", name: "name", disabled: false })),
                react_1.default.createElement("div", { className: "table__td" },
                    react_1.default.createElement(TextInput_1.default, { type: "text", name: "acNumber", altLabel: "AC Number", disabled: false })),
                react_1.default.createElement("div", { className: "table__td" },
                    react_1.default.createElement(Select_1.default, { name: "country", options: [
                            {
                                value: "UK",
                                text: "UK"
                            },
                            {
                                value: "IR",
                                text: "IR"
                            }
                        ] })),
                react_1.default.createElement("div", { className: "table__td" },
                    react_1.default.createElement(Select_1.default, { name: "accountType", options: [
                            {
                                value: "price",
                                text: "Price"
                            },
                            {
                                value: "fleet",
                                text: "Fleet"
                            },
                            {
                                value: "pod",
                                text: "POD"
                            }
                        ] })),
                react_1.default.createElement("div", { className: "table__td" },
                    react_1.default.createElement(Button_1.default, { type: "submit", title: "Save", value: "save", name: "command" })))),
        react_1.default.createElement("h2", null, "Upload Customers"),
        react_1.default.createElement("form", null,
            react_1.default.createElement("div", { className: "table__tr flex flex-row" },
                react_1.default.createElement("div", { className: "table__td" },
                    react_1.default.createElement(FileInput_1.default, { name: "newAttachment", files: attachments, multiple: false, accept: '.csv', onFileError: fileErrorHandler, onFileSelect: fileSelectHandler })),
                react_1.default.createElement("div", { className: "table__td" },
                    react_1.default.createElement(Button_1.default, { type: "button", title: "Upload", onClick: handleUpload, icon: busy && react_1.default.createElement(Loading_1.default, null) || null }, "Upload")),
                react_1.default.createElement("div", { className: "table__td" },
                    react_1.default.createElement("a", { href: "/docs/example-upload.csv", title: "View Example File", target: "_blank" }, "View Example File"))))));
};
exports.default = CustomerAdd;
